import React, { useEffect, useState } from "react";
import { Dropdown } from "../../../common/components/dropdown/Dropdown";
import useFormComponentState from "../../../common/forms/useFormComponentState";
import { api } from "../../searches/api";
import { CriterionLabel } from "./common/CriterionLabel";
import { SearchCriterion } from "./common/SearchCriterion";
import { requiredRolesType } from "../../../common/types/search/search";
import { visibilitySelectorType } from "../../../common/types/common";

interface SearchesCriterionProps {
	criterionKey: string;
	label?: string;
	namespace: string;
	prefix?: string;
	quickSearch?: boolean;
	requiredRoles?: requiredRolesType;
	visibilitySelector?: visibilitySelectorType;
}

export function SearchesCriterion({
	criterionKey,
	label,
	requiredRoles,
	namespace,
	prefix,
	quickSearch = false,
	visibilitySelector,
}: SearchesCriterionProps) {
	const { currentInput, onInputChange, onClearInput } =
		useFormComponentState(criterionKey);
	const [searches, setSearches] = useState(null);
	const searchesExist = searches && searches.length > 0;
	const defaultLabel = "None";
	const defaultDropdownItem = { key: "none", value: defaultLabel };
	let dropdownItems = [defaultDropdownItem];

	useEffect(() => {
		let isMounted = true;

		if (!searches) {
			api(namespace).load((data) => {
				if (isMounted) {
					setSearches(data);
				}
			});
		}

		return () => {
			isMounted = false;
		};
	}, []);

	if (searchesExist) {
		dropdownItems = [
			...dropdownItems,
			...searches.map((search) => ({
				key: search.id,
				value: search.name,
			})),
		];
	}

	const dropdownToggle =
		currentInput && searches
			? dropdownItems.find((item) => item.key === currentInput).value
			: defaultLabel;

	const inputLabel = label && (
		<label htmlFor={criterionKey}>
			<CriterionLabel label={label} prefix={prefix} />
		</label>
	);

	const handleDropdownItemClick = (id) => {
		const key = dropdownItems.find((item) => item.key === id).key;
		key === defaultDropdownItem.key ? onClearInput() : onInputChange(key);
	};

	return (
		<SearchCriterion
			label={label}
			prefix={prefix}
			quickSearch={quickSearch}
			requiredRoles={requiredRoles}
			visibilitySelector={visibilitySelector}
		>
			<div className="criterion dropdown single-choice-dropdown">
				{inputLabel}
				<Dropdown
					dropdownToggle={dropdownToggle}
					dropdownItems={dropdownItems}
					dropdownItemsEmptyText="You have not saved any searches yet."
					dropdownKey={criterionKey}
					label={label}
					loading={!searches}
					onDropdownItemClick={handleDropdownItemClick}
					preselected
					quickSearch={quickSearch}
				/>
			</div>
		</SearchCriterion>
	);
}
